import { Stack } from 'expo-router';
import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateChatChatIdMediaLayoutRoute() {
  return (
    <ModalStack changeStatusBarStyle={false}>
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
          gestureEnabled: true,
        }}
      />
    </ModalStack>
  );
}
